// extracted by mini-css-extract-plugin
export default {"bar":"StatsBar_bar__F3gy3","stat":"StatsBar_stat__3ssmh","num":"StatsBar_num__JaQ9j","label":"StatsBar_label__svyUc"};